// line-clamp/client.js
/* Truncates text to specified number of lines and adds an ellipse.
 * Assumes the following:
 * If the height of the parent is smaller than the child (explicitly set in the css),
    then resize the child element to match the parent and add ellipses to the text.
  Else, if the parent and child are the same height, attempt to estimate what the height
    of the child should be in order to restrict to the requested number of lines
    (3 by default, if not explicitly set);
*/
import { EventPubSub } from '../element/public/src/utils/pubSub.js';
import { RERENDER_ALL } from '../element/shared/enums/events.js';
import _ from '../element/shared/utils/dont-need-lodash.js';

// Trim the child element to the target height and add ellipses
function trim(element, targetHeight) {
  const height = targetHeight;
  const marginOfError = height / 4;

  while (_.height(element) > (height + marginOfError)) {
    element.textContent = element.textContent.replace(/\W*\s(\S)*$/, '...');
  }
}

// Estimate ideal height if parent size is not set explicitly
function estimateMaxHeight(element, requestedLines) {
  const lines = requestedLines || 3;
  const fontSize = getComputedStyle(element, null).fontSize;
  const lineHeight = Math.floor(parseInt(fontSize.replace('px', ''), 10) * 1.3);

  return lineHeight * lines;
}

// check the heights of parent and child and trim accordingly
function clamp() {
  Array.prototype.forEach.call(document.querySelectorAll('.component.line-clamp'), (parent) => {
    if (parent.classList.contains('clamped')) {
      return null;
    }

    const child = parent.children[0];
    if (child) {
      const maxHeight = (_.height(parent) < _.height(child) && _.height(parent) > 0) ?
        _.height(parent) :
        estimateMaxHeight(child, parent.dataset['lines']);

      parent.classList.add('clamped');
      if (_.height(child) > maxHeight) {
        trim(child, maxHeight);
      }

      if (parent.dataset['link']) {
        const link = {
          aria: (parent.dataset[_.camelCase('link-aria')]) ? parent.dataset[_.camelCase('link-aria')] : parent.dataset['link'],
          text: parent.dataset['link'],
          cms_id: parent.dataset[_.camelCase('cms-id')],
          extra_classes: parent.dataset[_.camelCase('extra-classes')],
        };
        const linkView = ` <a class="link-view ${link.extra_classes}" ${link.cms_id && `data-cms-id="${link.cms_id}"`} href="#" aria-label="${link.aria}">${link.text}</a>`;
        child.appendChild(linkView);
      }
    }
    return null;
  });
}

export default function lineClamp() {
  EventPubSub.subscribe(RERENDER_ALL, () => clamp());
  clamp();

  /* Running clamp() at regular intervals to ensure
  clamping after css is loaded and painted on window */
  let noOfTimesClamped = 0;
  const timesToBeClamped = 4;
  const clampInterval = 750;
  const clampedInterval = setInterval(() => {
    if (noOfTimesClamped === timesToBeClamped) {
      window.clearInterval(clampedInterval);
    }
    noOfTimesClamped += 1;
    clamp();
  }, clampInterval);
}
